import { ICombinedUserData } from 'lib/context';
import {
  checkIfFeatureIsEnabled,
  productFeature,
} from 'lib/utils/productFeature';
import { NOTIFICATION_TYPES } from './types';
import { TFunction } from 'i18next';

export const capitalizeFirstLetter = (btnTxt: string, t: TFunction) => {
  if (btnTxt === NOTIFICATION_TYPES.EMAIL_NOT_DELIVERED) {
    return t('Email not Delivered');
  }
  if (btnTxt === NOTIFICATION_TYPES.SALES) {
    return t('Test Drive Schedule');
  }
  if (btnTxt === NOTIFICATION_TYPES.REPLY) {
    return t('Video Replies');
  }
  if (btnTxt === NOTIFICATION_TYPES.REACTIONS_COMMENTS) {
    return t('Comments and Reactions');
  }
  if (btnTxt === NOTIFICATION_TYPES.PUSHED_TO_VDP) {
    return t('Video Pushed to VDP');
  }
  if (btnTxt === NOTIFICATION_TYPES.VIDEO_DELETE) {
    return t('Video Delete');
  }
  if (btnTxt === NOTIFICATION_TYPES.LIVE) {
    return t('Meetings');
  }
  if (btnTxt === NOTIFICATION_TYPES.EMAIL_OPENED) {
    return t('Email Opened');
  }
  if (btnTxt === NOTIFICATION_TYPES.VIDEO_REQUEST) {
    return t('Video Request');
  }
  if (btnTxt === NOTIFICATION_TYPES.VIDEO_REQUEST_RESPONSE) {
    return t('Video Request Response');
  }
  if (btnTxt === NOTIFICATION_TYPES.VIEW) {
    return t('Video Viewed');
  }
  if (btnTxt === NOTIFICATION_TYPES.CTA) {
    return t('CTA Clicked');
  }
  if (btnTxt === NOTIFICATION_TYPES.QUOTES) {
    return t('Quote Updates');
  }
  if (btnTxt === NOTIFICATION_TYPES.FILES) {
    return t('File Shared');
  }
  if (btnTxt === NOTIFICATION_TYPES.BOARDS) {
    return t('Board Shared');
  }
  return btnTxt.charAt(0).toUpperCase() + btnTxt.slice(1).toLowerCase();
};

export const getViewBtnText = (
  type: any,
  meta: any,
  userData: ICombinedUserData,
  t: TFunction
) => {
  const notificationType = type.toUpperCase();

  if (
    notificationType === NOTIFICATION_TYPES.EMAIL_NOT_DELIVERED ||
    notificationType === NOTIFICATION_TYPES.VIEW
  ) {
    const hasAnalytics = checkIfFeatureIsEnabled(
      userData,
      productFeature.HOTSPOTS_AND_ANALYTICS
    );
    return hasAnalytics ? t('View Analytics') : t('Upgrade to Pro');
  }
  if (notificationType === NOTIFICATION_TYPES.CTA) {
    const hasCtas = checkIfFeatureIsEnabled(userData, productFeature.CTAS);
    return hasCtas ? t('View Analytics') : t('Upgrade to Pro');
  }

  if (notificationType === NOTIFICATION_TYPES.SALES) {
    return t('View Drive Info');
  }
  if (notificationType === NOTIFICATION_TYPES.REPLY) {
    return t('View Video Reply');
  }
  if (notificationType === NOTIFICATION_TYPES.REACTIONS_COMMENTS) {
    // get button text based on reaction type
    switch (meta.reactionType) {
      case '1':
        return t('View Comments');
      case '2':
        return t('View Reactions');
      case '3':
        return t('View Comments & Reactions');
      default:
        return '';
    }
  }
  if (notificationType === NOTIFICATION_TYPES.PUSHED_TO_VDP) {
    return t('View pushed to VDP page');
  }

  if (notificationType === NOTIFICATION_TYPES.LIVE) {
    return t('Join Meeting');
  }

  if (notificationType === NOTIFICATION_TYPES.REPORTS) {
    return t('Download Report');
  }

  if (notificationType === NOTIFICATION_TYPES.VIDEO_DELETE) {
    return t('Review request');
  }

  if (notificationType === NOTIFICATION_TYPES.EMAIL_OPENED) {
    return t('View Email Opened');
  }

  if (notificationType === NOTIFICATION_TYPES.VIDEO_REQUEST) {
    return t('Review Request');
  }

  if (notificationType === NOTIFICATION_TYPES.VIDEO_REQUEST_RESPONSE) {
    return t('View Video');
  }

  let btnTxt = t('View');
  let appendTxt = capitalizeFirstLetter(type, t);
  return btnTxt + ' ' + appendTxt.slice(0, -1);
};
